import { DataType } from "shared/types";

import { CountTypeEnum } from "pages/Dashboard/components/constants";
import { BarCell } from "pages/shared/Dashboard/BarCell";

import Tooltip from "features/components/Tooltip";
import { SECONDARY_CHART_COLOR } from "features/ui/charts/constants";

import HeaderText from "./HeaderText";
import {
  ColumnCellRenderProps,
  ColumnHeaderRenderProps,
  SmartGroupColumnDefinition,
  SmartGroupColumnId,
} from "./types";

export const allTimeCountColumn: SmartGroupColumnDefinition = {
  id: SmartGroupColumnId.ALL_TIME_COUNT,

  getSchema: ({ allTimeAccessor }) => ({
    accessor: allTimeAccessor,
    label: "",
    dataType: DataType.JSX,
    columnWidth: 150,
  }),

  renderHeader: ({ context }: ColumnHeaderRenderProps) => {
    const { countLabel, countType, vehiclesPeriod, addProductionSuffix, t } =
      context;

    const headerText =
      countType === CountTypeEnum.FRC_IMPACT
        ? t("schema:dashboard.frc_tooltip")
        : addProductionSuffix
          ? t("schema:dashboard.count_in_last_of_production", {
              countLabel,
              period: vehiclesPeriod,
            })
          : t("schema:dashboard.count_in_last", {
              countLabel,
              period: vehiclesPeriod,
            });
    const headerLabel = addProductionSuffix
      ? t("schema:dashboard.last_period_of_prod", { period: vehiclesPeriod })
      : t("schema:dashboard.last_period", { period: vehiclesPeriod });

    return (
      <Tooltip title={headerText}>
        <HeaderText text={countLabel} secondaryText={headerLabel} />
      </Tooltip>
    );
  },

  renderCell: ({ row, context }: ColumnCellRenderProps) => {
    const { allTimeAccessor, maxAllTimeValue, countType } = context;

    return (
      <BarCell
        value={row[allTimeAccessor]}
        maxValue={maxAllTimeValue}
        barColor={SECONDARY_CHART_COLOR}
        isFRCImpact={countType === CountTypeEnum.FRC_IMPACT}
      />
    );
  },
};
